import { css } from '@emotion/core';
import { colors } from 'styles';

export const outline = css`
  outline: 1px solid ${colors.lighterGrey};
  background: ${colors.white};
`;
